import { postApi } from "./api_instance";

export const switchTokenValidationCall = async ({ token}) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/validate-switch-token",
      dispatch: () => {},
      data: {  token },
    });
    return data;
  } catch (error) {
    throw error;
  }
};


